import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Models } from '../../models/global.models';

function createInitialState(): Models.LoanOfficerNotesLeadForm {
  return <Models.LoanOfficerNotesLeadForm>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'loan-officer-notes-lead-store' })
export class LoanOfficerNotesLeadStore extends Store<Models.LoanOfficerNotesLeadForm> {
  constructor() {
    super(createInitialState());
  }
}
